module.exports = __webpack_public_path__ + "static/bg_business-a226b6bea6e5e94bba229715354bf47e.jpg";